import Component from "../abstracts/Component";
import { Matchmq } from "../utils/ResolutionHandler";

export default class TrackingComponent extends Component {
  get SELECTORS() {
    return {
      dataTracking: "[data-tracking-action]",
      fitersInput: ".js-filters-checkbox",
      trackingPayload: "[data-tracking-payload]",
      cartPage: ".t-cart",
      O2OCCSearchInput: "#sl__search__input"
    };
  }

  addToWishHelper(products, productCode) {
    return new Promise((resolve, reject) => {
      const findIndex = products.findIndex(elem => {
        return elem.id === productCode;
      });
      if (findIndex < 0) {
        reject("No prod found");
      }
      const product = products[findIndex];
      resolve(product);
    });
  }

  // retrieve object/sub-object identified by [data-tracking-payload] attribute and parse them with .data() method
  // to retriieve product JSON
  getTrackingPayloadData(el, list) {
    let elements;

    if (list == true) {
      elements = $(el).find(this.SELECTORS.trackingPayload);
    } else {
      elements = $(el)
        .closest(this.SELECTORS.dataTracking)
        .find(this.SELECTORS.trackingPayload);

      if (!elements.length) {
        elements = this.findNearbyTrackingPayload(el);
      }
    }

    let products = [];
    elements.each(function() {
      products.push($(this).data());
    });
    return products;
  }

  findNearbyTrackingPayload(el) {
    const $el = $(el);
    const ctx = this;
    let elements = $();

    $el.parents().each(function () {
      const $parent = $(this);
      const found = $parent.siblings(ctx.SELECTORS.trackingPayload).add($parent.find(ctx.SELECTORS.trackingPayload));
      if (found.length) {
        elements = found;
        return false;
      }
    });

    return elements;
  }



  getProductsArray(productCode) {
    let productsArray = document?.querySelectorAll(`[data-product-id="${productCode}"]`) || [];
    if (productsArray.length < 1) {
      productsArray = document.querySelectorAll(`[data-id="${productCode}"]`) || [];
    }
    return productsArray;
  }

  handleWishlistAddByString(productCode) {
    const productsArray = this.getProductsArray(productCode);
    if (productsArray.length < 1 && typeof products === "undefined") {
      this.warn("No product found for code: " + productCode);
      return;
    }
    const productData = this.getTrackingPayloadData(productsArray, false);
    const data = productData?.length > 0 ? productData : products ;
    if (data) {
      this.addToWishHelper(data, productCode)
        .then(product => {
          utag.wishlist_add(product);
        })
        .catch(() => {
          this.warn("Error during addToWishHelper execution");
        });
    } else {
      this.warn("No valid data for productCode: " + productCode);
    }
  }

  handleWishlistAddByObject(params) {
    const productCode = params?.productCode;
    if (!productCode) {
      this.warn("No productCode provided in params");
      return;
    }
    const productsArray = this.getProductsArray(productCode);
    const productData = productsArray.length > 0 ? this.getTrackingPayloadData(productsArray, false) : null;
    const data = typeof products !== "undefined" ? products : productData;
    if (!data) {
      this.warn("No valid product data found for code: " + productCode);
      return;
    }

    this.addToWishHelper(data, productCode)
      .then(product => {
        utag.wishlist_add(product);
      })
      .catch(() => {
        this.warn("Error during addToWishHelper execution");
      });
  }

  constructor() {
    super();
    this.actions = {
      // action triggered on clicking on "view more" button in listing
      // template ajax/t-category.jsp should add html tag with product-related + SELECTORS.trackingPayload data attributes
      loadMore: payload => {
        if (payload != null) {
          let products = this.getTrackingPayloadData($.parseHTML(payload), true);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          try {
            this.log("tracking loadMore event with " + products.length + " more products");
            window.listViewMore(products);
          } catch (e) {
            this.log("listViewMore tracking function not available");
          }
        }
      },

      // from category listing or search listin on clicking product box
      productView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          // looking for first children of [data-tracking-action] el, with [data-tracking-payload] data attribute
          let product = products[0];
          // TODO: add other templates..
          if (typeof product.template !== "undefined") {
            if ("category-page" == product.template || "na:t-editorial-listing" == product.template || "na:t-editorial" == product.template) {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch (e) {
                this.warn("listProdClick tracking function not available");
              }
            } else if (product.template == "na:c-recommendation-engine") {
              try {
                this.log("tracking listCarouselClick event for product: " + product.id);
                window.listCarouselClick("recommendation-engine-SF", product);
              } catch (e) {
                this.warn("listCarouselClick tracking function not available");
              }
            } else if ("search-page" == product.template) {
              try {
                this.log("tracking searchProdClick event for product: " + product.id);
                window.searchProdClick(product);
              } catch (e) {
                this.warn("searchProdClick tracking function not available");
              }
            } else {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch (e) {
                this.warn("listProdClick tracking function not available");
              }
            }
          }
          if (product.isAlgoliaEnabled) {
            this.actions.algolia(params, el);
          }
        }
      },
      listCarouselView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          try {
            this.log("tracking type: rec_engine listCarouselClick event for product: " + product.id);
            window.listCarouselClick("recommendation-engine-SF", product);
          } catch (e) {
            this.warn("listCarouselClick tracking function not available");
          }
        }
      },
      lookView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          try {
            this.log("tracking listCarouselClick event for product: " + product.id);
            window.listCarouselClick("complete-your-outfit", product);
          } catch (e) {
            this.warn("listCarouselClick tracking function not available");
          }
        }
      },
      algolia: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          this.log("algolia " + product);
          product.position = product.position + 1; //Algolia è 1-based e non 0-based
          this.log("Algolia " + product.position + " " + product.id);
          $.ajax({
            url: "/action/ajax/algolia-notification",
            type: "post",
            cache: "false",
            data: {
              positionId: product.position
            },
            success: function(data) {
              console.log("algolia success");
            },
            error: function(errorObj, textStatus, errorThrown) {
              console.warn("algolia error");
            }
          });
        }
      },
      wishlistAdd: params => {
        if (typeof params === "string") {
          this.handleWishlistAddByString(params);
        } else {
          this.handleWishlistAddByObject(params);
        }
      },
      //called from AddToCartComponent.js
      addToCart: params => {
        let productCode = params.productCode || params;
        if (typeof productCode === "undefined") {
          this.warn("no productCode found");
          return;
        }
        try {
          this.log("tracking add to cart event with code: " + productCode);
          utag.cart_add(";" + productCode);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      removeProduct: params => {
        let productCode = params.productCode;
        if (typeof productCode === "undefined") {
          this.warn("no productCode found");
          return;
        }
        try {
          this.log("tracking removeProduct event with productCode: " + params.productCode);
          utag.cart_remove_click(productCode);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      removeQuantity: params => {
        let productCode = params.productCode;
        let price = params.price;
        if (typeof productCode === "undefined") {
          this.warn("no productCode found");
          return;
        }
        if (typeof price === "undefined") {
          this.warn("no price found");
          return;
        }
        try {
          this.log("tracking removeQuantity event with productCode: " + params.productCode);
          utag.cart_minus_click(productCode, 1, price);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      addQuantity: params => {
        let productCode = params.productCode;
        let price = params.price;
        if (typeof productCode === "undefined") {
          this.warn("no productCode found");
          return;
        }
        if (typeof price === "undefined") {
          this.warn("no price found");
          return;
        }
        try {
          this.log("tracking addQuantity event with productCode: " + params.productCode);
          utag.cart_plus_click(productCode, 1, price);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      newsletter: params => {
        const pos = params.pos;
        const type = params.type ? "-" + params.type : "";
        this.log("[Tracking] NL-Subscription, type: " + type + " pos: " + pos);
        ga("send", "event", "NL", "NL-Subscription" + type, pos);
      },
      formisimo: params => {
        this.log("formisimo: ", params);
        if (typeof window.TealiumConversionForm == "function") {
          this.log("TealiumConversionForm: ", params);
          window.TealiumConversionForm(params.formId, params.result);
        } else {
          //keep data in a global var
          window.Tealium.trackingData = {
            formId: params.formId,
            formResult: params.result
          };
        }
      },
      sizeSelection: params => {
        let code = params.code;
        if (typeof code === "undefined") {
          this.warn("no code found");
          return;
        }
        try {
          this.log("tracking sizeSelection event with code: " + code);
          utag.size_selection();
          let mainSizeRow = document.querySelector(".c-sizes-row");
          mainSizeRow.dataset.errorMessage = "";
        } catch (e) {
          this.warn("Utag tracking is not available");
        }
      },
      notifyMe: (params, size) => {
        const product = window.products[0];
        if (size && size?.value) {
          product.size = size?.value;
        }
        let code = params;
        if (typeof code === "undefined") {
          this.warn("no code found");
          return;
        }
        try {
          this.log("tracking back in stock event with code: " + code);
          utag.back_in_stock(product);
        } catch (e) {
          this.warn("Utag tracking is not available");
        }
      },
      O2OCCSelect: params => {
        if (!this.isCartPage()) {
          return;
        }
        try {
          this.log("tracking 020 CC selected event");
          utag.click_collect("click");
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSearch: params => {
        if (!this.isCartPage()) {
          return;
        }

        let o2oCCSearchInput = $(this.SELECTORS.O2OCCSearchInput).val();
        try {
          this.log("tracking 020 CC store search event: " + o2oCCSearchInput);
          utag.click_collect(o2oCCSearchInput);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCLocalize: params => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log("tracking 020 CC localize event");
          utag.click_collect("localizza");
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSelectStore: params => {
        if (!this.isCartPage()) {
          return;
        }

        let storeName = params.storeName;
        if (typeof storeName === "undefined") {
          this.warn("no storeName found");
          return;
        }
        try {
          this.log("tracking 020 CC store select event: " + storeName);
          utag.click_collect("store:" + storeName);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      //called from FiltersComponent.js
      filterTracking: (params, orderBy) => {
        let facetCode = $(params).attr("data-facet-code");
        let facetValue = $(params).attr("data-code");
        if (orderBy === true) {
          facetCode = "orderBy";
          facetValue = $(params).attr("data-sortby-name");
        }
        if (facetValue != null) {
          this.log("Triggering filter " + facetCode + ": " + facetValue);
          try {
            this.log("tracking link event: " + facetValue);
            utag.link({
              filter: facetCode + ":" + facetValue,
              event_name: "filter_usage"
            });
          } catch (e) {
            this.warn("Utag tracking not available");
          }
        }
      },
      startChat: () => {
        utag.link({
          event_name: "chat_start"
        });
      },
      deleteChat: () => {
        utag.link({
          event_name: "chat_delete"
        });
      },
      addCartGiftCard: params => {
        utag.link({
          event_category: "gift card",
          event_action: "add to cart",
          event_label: "giftcart " + params,
          event_name: "giftcart_add_to_cart"
        });
      },
      newsletterSubscribe: params => {
        let position = params.trackingPosition;
        utag.link({
          event_name: "newsletter_subscribe",
          event_location: position
        });
      },
      signup: country => {
        console.log(country);
        utag.link({
          event_name: "sign_up",
          event_method: "manual",
          store_country: country
        });
      },
      whatsappStart: () => {
        utag.link({
          event_name: "whatsapp_start"
        });
      },
      shortcutCategoryView: params => {
        try {
          this.log("Tracking shortcut category click: " + params.shortcutLabel);
          var data = new Object();
          data["event_name"] = "select_content";
          data["event_location"] = params.shortcutNumber; // es. shortcut-micro_1, shortcut-macro_4 …
          data["event_detail"] = params.shortcutLabel; // es. our selection, clothing, pantaloni, abiti, …
          data["content_type"] = params.shortcutType; // es. shortcut-micro, shortcut-macro…
          utag.link(data);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      }
    };
  }

  removeDuplicateElements(items) {
    return Array.from(new Map(items.map(product => [product.id, product])).values());
  }

  carouselOnLoad() {
    //complete your outfit
    document.querySelectorAll("[data-id='complete-your-outfit']").forEach(carousel => {
      let products = this.getTrackingPayloadData(carousel, true);
      products = this.removeDuplicateElements(products);
      try {
        this.log("carousel type: complete_your_outfit with " + products.length + " products");
        window.listCarouselImpression("complete-your-outfit", products);
      } catch (e) {
        this.warn("listCarouselImpression tracking not available");
      }
    });

    //recommendation engine
    document.querySelectorAll("[data-js-component='RecommendationEngineComponent']").forEach(carousel => {
      let products = this.getTrackingPayloadData(carousel, true);
      try {
        this.log("carousel type: rec_engine with " + products.length + " products");
        window.listCarouselImpression("recommendation-engine-SF", products);
      } catch (e) {
        this.warn("listCarouselImpression tracking not available");
      }
    });
  }

  isCartPage() {
    let element = $(this.SELECTORS.cartPage);
    if (element.length > 0) {
      return true;
    }
    return false;
  }

  isLogged() {
    const locationPath = window.location + "";
    return locationPath.split("/")[3].split("?")[1] === "login=success";
  }

  getListString(codeList) {
    let listString = ";";

    $.each(codeList, function(index, value) {
      listString += value + ",;";
    });

    listString = listString.substr(0, listString.lastIndexOf(","));
    return listString;
  }

  //  isLookOnload() {
  //    if (document.querySelector('body').getAttribute('data-controller')==='Product') {
  //      let elem = document.querySelector('#complete-your-outfit');
  //      if (elem == null) {
  //        this.log('"complete-your-outfit" carousel not found');
  //        return;
  //      }
  //      let elemName = elem.id;
  //      if (Matchmq('767','0' )===true) {
  //        elem = elem.getElementsByClassName('cyo__mobile')[0];
  //      } else {
  //        elem = elem.getElementsByClassName('cyo__desktop')[0];
  //      }
  //      try {
  //        let products = this.getTrackingPayloadData(elem.children, true);
  //        if (products.length == 0 || typeof products === 'undefined') {
  //          this.warn("no products found in " + elemName + " carousel");
  //          return;
  //        }
  //        try {
  //          this.log("tracking '" + elemName + "' carousel with " + products.length + " products");
  //          window.listCarouselImpression(elemName, products);
  //        } catch(e) {
  //          this.warn("listCarouselImpression tracking not available");
  //        }
  //      } catch(e) {
  //        this.warn('"complete-your-outfit" carousel tracking not available');
  //      }
  //    }
  //  }

  trackAction(action, data, targetElement) {
    if (this.actions[action]) {
      if (typeof data["bs.tab"] != "undefined") {
        delete data["bs.tab"];
      }
      this.log("[Tracking] tracking action caught: " + action + " - with params: " + JSON.stringify(data));
      this.actions[action](data, targetElement);
    } else {
      this.warn("[Tracking] no tracking manager found for action " + action);
    }
  }

  bindEvents() {
    this.$on(
      "click",
      ({ event }) => {
        if (!$(event.currentTarget).data("disabled") && $(event.currentTarget).data("trackingAction")) {
          let data = $(event.currentTarget).data();
          let action = data.trackingAction;
          this.trackAction(action, data, event.target);
        }
      },
      "body",
      this.SELECTORS.dataTracking
    );

    if (this.isLogged()) {
      this.trackAction("login");
    }
  }

  bindCustomEvents() {
    // ??? custom "track" events
    $("body").on("track", (e, action, params) => {
      const data = [].slice.call(arguments).splice(2);
      this.trackAction(action, data);
    });

    // tracking loadMore button
    this.$on(this.$customEvents.TRACKING.loadMore, e => {
      this.log("emitting tacking event: " + this.$customEvents.TRACKING.loadMore);
      this.actions["loadMore"](e.payload);
    });
  }

  initiateTracking() {
    const ctx = this;
    const $formisimo = $("formisimo");
    window.Tealium = {};

    if ($formisimo.length > 0) {
      $formisimo.each(function() {
        const $this = $(this);
        const data = [{ formId: $this.data("formId"), result: $this.data("formResult") }];
        ctx.trackAction("formisimo", data);
      });
    }
  }

  render() {
    this.initiateTracking();
    this.bindEvents();
    this.bindCustomEvents();
    window.addEventListener("load", event => {
      //TODO remove impl this.isLookOnload();
      this.carouselOnLoad();
    });
  }
}
